import API from './API';
var PrizeDistributorService = {
    getPrizeDistributor: function (id, config) {
        return API.get("/prize_distributors/".concat(id), config);
    },
    getPrizeDistributors: function (config) {
        return API.get('/prize_distributors', config);
    },
    distribute: function (data, config) {
        return API.post('/prize_distributors/' + data.id + '/distribute', data, config);
    }
};
export default PrizeDistributorService;
